import { render } from "./BookingExtrasModalCase4.vue?vue&type=template&id=015923c0"
import script from "./BookingExtrasModalCase4.vue?vue&type=script&lang=js"
export * from "./BookingExtrasModalCase4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingExtrasModalCase4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015923c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015923c0', __exports__)) {
    api.reload('015923c0', __exports__)
  }
  
  module.hot.accept("./BookingExtrasModalCase4.vue?vue&type=template&id=015923c0", () => {
    api.rerender('015923c0', render)
  })

}


export default __exports__